import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

type AxiosLikeError = {
  message?: string;
  response?: {
    status?: number;
    data?: unknown;
  };
};

/** RTK Query requires serializable error values — not raw AxiosError instances. */
export const serializeQueryError = (error: unknown): FetchBaseQueryError => {
  if (typeof error === 'object' && error !== null && 'response' in error) {
    const axiosError = error as AxiosLikeError;
    const status = axiosError.response?.status;

    if (typeof status === 'number') {
      return {
        status,
        data:
          axiosError.response?.data ?? axiosError.message ?? 'Request failed'
      };
    }

    return {
      status: 'CUSTOM_ERROR',
      error: axiosError.message ?? 'Request failed',
      data: axiosError.response?.data ?? axiosError.message ?? 'Request failed'
    };
  }

  if (error instanceof Error) {
    return {
      status: 'CUSTOM_ERROR',
      error: error.message
    };
  }

  return {
    status: 'CUSTOM_ERROR',
    error: String(error)
  };
};

export const getErrorMessage = (error: unknown): string => {
  if (typeof error === 'object' && error !== null && 'message' in error) {
    const { message } = error as { message?: unknown };
    if (typeof message === 'string') {
      return message;
    }
  }

  return 'Unknown error';
};
